import { MdGridView, MdViewList } from 'react-icons/md';

import { cn } from '../../lib/cn';

export type ReviewsView = 'table' | 'grid';

/** Two icon buttons: table or card grid. */
export function ViewSwitch({
  value,
  onChange,
}: {
  value: ReviewsView;
  onChange: (value: ReviewsView) => void;
}) {
  return (
    <div
      role="group"
      aria-label="Affichage"
      className="inline-flex rounded-field border border-border-subtle bg-surface p-0.5"
    >
      {(
        [
          { value: 'table', label: 'Tableau', icon: <MdViewList /> },
          { value: 'grid', label: 'Grille', icon: <MdGridView /> },
        ] as const
      ).map((o) => (
        <button
          key={o.value}
          type="button"
          title={o.label}
          aria-label={o.label}
          aria-pressed={value === o.value}
          onClick={() => onChange(o.value)}
          className={cn(
            'grid size-9 place-items-center rounded-md text-xl transition-colors',
            value === o.value
              ? 'bg-brand-50 text-brand-600'
              : 'text-content-muted hover:bg-surface-muted hover:text-content',
          )}
        >
          {o.icon}
        </button>
      ))}
    </div>
  );
}
